import { t } from 'i18next'
import React from 'react'
import ModalV2 from 'components/ModalV2/ModalV2'
import ModalV2Buttons from 'components/ModalV2Buttons/ModalV2Buttons'
import { DocumentsModalBody } from '../../modals/documentsModalV2Shared'

const ModalForGoBack = ({goBack, goBackModalStatus, toggleGoBackModalStatus}) => {
	return (
		<ModalV2
			open={goBackModalStatus}
			onClose={goBack}
			width={480}
			title={t("vatReturns.warning")}
			content={
				<DocumentsModalBody>
					<p>{t("einvoice:ui.exemption.goBackConfirm")}</p>
				</DocumentsModalBody>
			}
			footer={
				<ModalV2Buttons
					onCancel={goBack}
					onConfirm={toggleGoBackModalStatus}
					cancelText={t("einvoice:ui.common.yes")}
					confirmText={t("einvoice:ui.common.no")}
					variant="primary"
				/>
			}
		/>
	)
}

export default ModalForGoBack
